
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const reasons = [
  {
    icon: 'ri-shield-check-line',
    title: 'Seguridad Garantizada',
    description: 'El software original recibe actualizaciones de seguridad constantes, protegiendo tu empresa contra vulnerabilidades y amenazas cibernéticas.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Cumplimiento Legal',
    description: 'Evitá sanciones y multas por uso de software pirata. Las licencias originales te mantienen dentro del marco legal vigente en Argentina.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Soporte Oficial',
    description: 'Accedé al soporte técnico del fabricante y a documentación completa para resolver cualquier inconveniente de forma rápida y profesional.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Rendimiento Óptimo',
    description: 'Los programas originales funcionan sin limitaciones, sin errores forzados y con todas las funcionalidades habilitadas para máxima productividad.',
  },
];

export function WhyLegal() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,255,240,0.04),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`text-center mb-14 anim-fade-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            ¿Por qué usar <strong className="text-neon-400 text-neon-glow-sm">Software Legal</strong>?
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Invertir en licencias originales es proteger tu negocio, tus datos y tu reputación profesional
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((item, index) => (
            <article
              key={index}
              className="bg-gray-900/80 rounded-xl p-6 border border-gray-800 hover:border-neon-400/40 transition-all duration-300 hover:shadow-neon group hover-lift hover-glow-card"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-neon-400/10 border border-neon-400/20 rounded-lg mb-5 group-hover:bg-neon-400/20 group-hover:shadow-neon-sm transition-all duration-300 group-hover:scale-110">
                  <i className={`${item.icon} text-2xl text-neon-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                  <strong>{item.title}</strong>
                </h3>
                <p className="text-xs text-gray-400 leading-relaxed">{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
